export const PropertyChangedEventNames: any = {
  customer_application_primaryPolicy_insuredType: 'customer_application_primaryPolicy_insuredType_changed',
  customer_application_primaryPolicy_ownerType: 'customer_application_primaryPolicy_ownerType_changed',
  customer_application_primaryPolicy_beneficiaryType: 'customer_application_primaryPolicy_beneficiaryType_changed',
  customer_application_primaryPolicy_contingentBeneficiaryType:
    'customer_application_primaryPolicy_contingentBeneficiaryType_changed',
  customer_application_primaryPolicy_beneficiaryChildrenEvenSplit:
    'customer_application_primaryPolicy_beneficiaryChildrenEvenSplit_changed',
  customer_application_primaryPolicy_hasContingentBeneficiary:
    'customer_application_primaryPolicy_hasContingentBeneficiary_changed',
  customer_application_primaryPolicy_contingentBeneficiaryChildrenEvenSplit:
    'customer_application_primaryPolicy_contingentBeneficiaryChildrenEvenSplit_changed',
  customer_application_primaryPolicy_reasonForInsuranceShort:
    'customer_application_primaryPolicy_reasonForInsuranceShort_changed',
  customer_application_primaryPolicy_primaryBeneficiary:
    'customer_application_primaryPolicy_primaryBeneficiary_changed',
  customer_application_primaryPolicy_contingentBeneficiary:
    'customer_application_primaryPolicy_contingentBeneficiary_changed',
  customer_application_primaryPolicy_isMinor: 'customer_application_primaryPolicy_isMinor_changed',
  customer_application_primaryPolicy_waiverPremium: 'customer_application_primaryPolicy_waiverPremium_changed',
};
